module.exports = __webpack_public_path__ + "static/OurValues3-mobile-ca3246dd6dd59587b89f848c03be01d7.png";